import React from 'react'
import { statusPillLabel } from '../component/status-pill'

// The workspace's one pill (sso-workspace.scss .sw-pill): rounded, soft
// tinted background, coloured dot, semibold small text. Tones: ok, warn,
// bad, info; anything else renders neutral.
export const Pill = ({ tone, title, children }) =>
  <span className={`sw-pill ${tone || ''}`.trim()} title={title}>{children}</span>

// StatusPill's domain states in the workspace's pill: same labels and hover
// text as every other page, the mockup's tones.
const DOMAIN_PILL_TONE = { verified: 'ok', overridden: 'info', at_risk: 'warn', deactivated: 'bad', pending: 'warn' }
export const domainPillTone = state => DOMAIN_PILL_TONE[state] || null

export const DomainPill = ({ tone, title }) =>
  <Pill tone={domainPillTone(tone)} title={title}>{statusPillLabel(tone)}</Pill>
